import script from "./ReturnView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReturnView.vue?vue&type=script&lang=ts&setup=true"

import "./ReturnView.vue?vue&type=style&index=0&id=6f5d778c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f5d778c"]])

export default __exports__